// Browser-history metadata only: no URLs, search terms or bearer tokens are stored.
export const NAV_MARKER = 'billfac_page_back_v1';
const DOCUMENT_LISTS = { factuur: '/facturen', offerte: '/offertes', bestelbon: '/bestelbonnen', leverbon: '/leveringsbonnen', creditnota: '/creditnotas', proforma: '/proforma' };
const PUBLIC_PREFIXES = ['portaal', 'bevestig-bestelling', 'klant-display', 'lever-tekenen', 'rit', 'verkooprit'];
const ACCOUNT_PATHS = ['/login', '/register', '/wachtwoord-vergeten', '/wachtwoord-reset', '/auth/callback'];

export const documentListPath = type => Object.prototype.hasOwnProperty.call(DOCUMENT_LISTS, type) ? DOCUMENT_LISTS[type] : '/facturen';
export const pageFingerprint = location => {
  const value = `${location.pathname}${location.search || ''}${location.hash || ''}`;
  let hash = 2166136261;
  for (const char of value) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
  return (hash >>> 0).toString(36);
};

export const navigationScope = (pathname, user) => {
  if (pathname === '/shop/login' || pathname.startsWith('/shop/setup/')) return 'shop-account';
  if (pathname === '/shop' || pathname.startsWith('/shop/')) return 'shop';
  if (ACCOUNT_PATHS.includes(pathname)) return 'account';
  const prefix = pathname.split('/')[1];
  if (PUBLIC_PREFIXES.includes(prefix)) return `public:${prefix}`;
  const identity = user?.id || user?._id;
  return identity ? `app:${identity}:${user?.tenant_id || user?.bedrijf_id || ''}:${user?.role || ''}` : 'anonymous';
};

export const fallbackPage = (location, user) => {
  const path = location.pathname;
  if (PUBLIC_PREFIXES.includes(path.split('/')[1])) return null;
  if (path === '/shop' || path.startsWith('/shop/')) return path === '/shop/login' || path.startsWith('/shop/setup/') ? '/shop/login' : '/shop/bestellen';
  if (ACCOUNT_PATHS.includes(path) || !user) return '/login';
  if (path.startsWith('/schemas/')) return '/herhaald';
  if (path.startsWith('/documenten/')) return documentListPath(new URLSearchParams(location.search).get('type'));
  if (path.startsWith('/inkomende-documenten/')) return '/inkomende-documenten';
  if (path.startsWith('/leveranciers/')) return '/leveranciers';
  if (path.startsWith('/instellingen/')) return '/instellingen';
  if (path.startsWith('/artikels/')) return '/artikels';
  if (path.startsWith('/leveringsbonnen/')) return '/leveringsbonnen';
  if (path === '/dagontvangsten') return '/leveringsbonnen/snel-scan';
  if (path.startsWith('/klantbezoeken/')) return '/klantbezoeken';
  return user?.role === 'verkoper' && !user?.is_admin ? '/verkoop' : '/dashboard';
};

export const isNavigationPage = (path, scope) => !['/', '/producten', '/shop', '/auth/callback'].includes(path) && scope !== 'anonymous';

export const historyMarker = ({ scope, index, view, action, previous, saved }) => {
  const valid = marker => marker?.version === 1 && marker.scope === scope && Array.isArray(marker.trail);
  let trail = [];
  if (valid(saved) && saved.index === index && saved.view === view) trail = saved.trail;
  else if (previous?.scope === scope && valid(previous.marker)) {
    if (action === 'PUSH' && previous.index < index) {
      trail = [...previous.marker.trail, ...(previous.eligible ? [{ index: previous.index, view: previous.view }] : [])];
    } else if (action === 'REPLACE' && previous.index === index) trail = previous.marker.trail;
  }
  trail = trail.filter(entry => entry && Number.isInteger(entry.index) && entry.index >= 0 && entry.index < index && typeof entry.view === 'string');
  while (trail.length && trail[trail.length - 1].view === view) trail.pop();
  return { version: 1, scope, index, view, trail: trail.slice(-64) };
};